import React from "react";

export const NoiseOverlay = () => <div className="noise-overlay" aria-hidden="true" />;
